import getGraphQlClient from '~graphql/getGraphQlClient';
import {
  CREATE_EDITOR_CANVAS,
  UPDATE_EDITOR_CANVAS,
  GET_EDITOR_CANVAS_BY_ID,
} from '../queries/editorCanvas';
import { unmarshalGraphqlResponse } from '~graphql/utils';

export const createEditorCanvas = async (fields) => {
  const graphQlClient = await getGraphQlClient();

  const response = await graphQlClient.mutate({
    variables: { fields },
    mutation: CREATE_EDITOR_CANVAS,
  });

  const result = unmarshalGraphqlResponse(response.data, 'createEditor_canvas');

  return result.editor_canvas;
};

export const updateEditorCanvas = async (id, fields) => {
  const graphQlClient = await getGraphQlClient();

  const response = await graphQlClient.mutate({
    variables: { id, fields },
    mutation: UPDATE_EDITOR_CANVAS,
  });

  const result = unmarshalGraphqlResponse(response.data, 'updateEditor_canvas');

  return result.editor_canvas;
};

export const fetchEditorCanvasById = async (id) => {
  const graphQlClient = await getGraphQlClient();

  const response = await graphQlClient.query({
    variables: { id },
    query: GET_EDITOR_CANVAS_BY_ID,
  });

  return unmarshalGraphqlResponse(response.data, 'getEditorCanvas');
};
